import { render, staticRenderFns } from "./new-client.vue?vue&type=template&id=ba2b31ea"
import script from "./new-client.vue?vue&type=script&lang=js"
export * from "./new-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports